export default function (props: any) {
    return (
        <svg width="138px" height="51px" viewBox="0 0 138 51" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="M端" transform="translate(-13.000000, -2397.000000)" stroke="#12B54C" strokeWidth="3">
                    <g id="编组-11" transform="translate(0.000000, 2392.977221)">
                        <path
                            d="M49.2543229,43.3917024 C25.9983641,39.059263 17.189984,32.3765654 22.8291826,23.3436096 C26.894655,16.831473 39.2213561,10.9856438 59.8935987,8.06504653 C80.5658412,5.1444492 107.186337,8.06504653 124.102389,13.016661 C155.856377,24.7366551 152.937602,42.0048673 136.451373,47.9574817 C119.08104,54.2513229 38.8101381,58.3504214 14.0807945,35.6168103"
                            id="路径备份-2"
                            transform="translate(81.311564, 29.901533) rotate(-6.000000) translate(-81.311564, -29.901533) "
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
